"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Styling_1 = require("../../Styling");
exports.getLayerStyles = function (props) {
    return {
        root: [{
                // Prioritize the Keytips above all other Layers
                zIndex: Styling_1.ZIndexes.KeytipLayer
            }]
    };
};
exports.getStyles = function (props) {
    return {
        innerContent: [tslib_1.__assign({}, Styling_1.hiddenContentStyle, { visibility: 'hidden' })]
    };
};
//# sourceMappingURL=KeytipLayer.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/KeytipLayer/KeytipLayer.styles.js
// module id = 423
// module chunks = 0